module.exports = __webpack_public_path__ + "img/canpay-side-logo-lite.a275209b.png";